import cookiesManager from '../utils/cookies-manager';

export default function initBannerNews(): void {
    const $bannerNews = document.querySelectorAll<HTMLElement>('.js-banner-news');
    $bannerNews.forEach($container => {
        new BannerNews($container);
    });
}

class BannerNews {
    $el: HTMLElement | null | undefined;
    $closeButton: HTMLButtonElement | null | undefined;
    private resizeObserver: ResizeObserver | null = null;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$closeButton = this.$el?.querySelector('.js-close-button') as HTMLButtonElement;
        this.init();
    }

    init(): void {
        const bannerNewsVersion = this.$el?.dataset.version as string;
        
        document.addEventListener('DOMContentLoaded',() => {
            const bannerNewsCookieExists = cookiesManager.getCookie(bannerNewsVersion);
            if (!bannerNewsCookieExists || bannerNewsCookieExists !== bannerNewsVersion) {
                this.$el?.classList.remove('hidden');
                this.updateBannerHeight();
                this.initResizeObserver();
            }
        });

        this.$closeButton?.addEventListener('click', () => {
            this.$el?.classList.add('hidden');
            document.body.style.setProperty('--height-banner-alert', '0px');
            this.destroyResizeObserver();
            cookiesManager.setCookie(bannerNewsVersion, true);
        });
    }

    private updateBannerHeight(): void {
        if (this.$el) {
            const height = this.$el.offsetHeight;
            document.body.style.setProperty('--height-banner-alert', `${height}px`);
        }
    }

    private initResizeObserver(): void {
        this.resizeObserver = new ResizeObserver(() => {
            this.updateBannerHeight();
        });

        if (this.$el) {
            this.resizeObserver.observe(this.$el);
        }
    }

    private destroyResizeObserver(): void {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }
}
